import { HttpErrorResponse, HttpStatusCode } from '@angular/common/http';
import { ExportUsersRES } from '../api';
import { ErrorMessages } from '../constants';
import { ExportUsersModel, ReqStatus } from '../models';

export const translateExportUsersRes = (
  apiResponse: ExportUsersRES | HttpErrorResponse
): ExportUsersModel => {
  const isHttpError = apiResponse instanceof HttpErrorResponse ? true : false;
  return {
    data: null,
    errors: [
      {
        message: apiResponse.message,
        status: apiResponse.status
          ? HttpStatusCode.Ok
          : HttpStatusCode.InternalServerError
      }
    ],
    pageState: null,
    reqState: {
      cyberCode: isHttpError ? 0 : (apiResponse as ExportUsersRES).cyberCode,
      message: isHttpError ? ErrorMessages.PORTAL_ERROR : apiResponse.message,
      reqStatus: isHttpError ? ReqStatus.ERROR : ReqStatus.SUCCESS,
      httpCode: null,
      modalStatus: null
    }
  };
};
